import {firstNavigationSettled, RouterLike} from './first-navigation';

/** Id statického spinneru v `src/index.html`. */
export const BOOT_PRELOADER_ID = 'gg-boot';

/**
 * Pojistka: kdyby první navigace nikdy neskončila (zaseknutý chunk, chyba mimo router),
 * spinner nesmí uživatele uvěznit. Běžná první navigace končí v řádu sekund.
 */
export const BOOT_PRELOADER_TIMEOUT_MS = 15_000;

/** Musí odpovídat `transition: opacity 0.25s` v inline stylu `index.html`. */
const FADE_OUT_MS = 280;

/** Sundá statický boot preloader z `index.html` (`#gg-boot`). Idempotentní. */
export function removeBootPreloader(doc: Document = document): void {
    const el = doc.getElementById(BOOT_PRELOADER_ID);
    if (!el) return;
    el.classList.add('fade-out');
    setTimeout(() => el.remove(), FADE_OUT_MS);
}

/**
 * Drží boot preloader až do konce první navigace (guardy + lazy chunk cílové route), ne jen
 * do resolvu `bootstrapApplication` — s výchozím `enabledNonBlocking` bootstrap skončí ještě
 * před guardy a uživatel by koukal na prázdnou plochu s tenkým progress barem.
 *
 * Konec navigace definuje `firstNavigationSettled` (redirect z guardu na login konec není).
 * Bez jakékoli události ho sundá timeout.
 */
export function holdBootPreloaderUntilFirstNavigation(
    router: RouterLike,
    doc: Document = document,
    timeoutMs: number = BOOT_PRELOADER_TIMEOUT_MS,
): void {
    const fallback = setTimeout(() => {
        subscription.unsubscribe();
        removeBootPreloader(doc);
    }, timeoutMs);

    const subscription = firstNavigationSettled(router).subscribe(() => {
        clearTimeout(fallback);
        removeBootPreloader(doc);
    });
}
